import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useVazaoBombasSection } from "./use-vazao-bombas-section";
import { VazaoBombasSectionView } from "./view-vazao-bombas-section";

export function VazaoBombasSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useVazaoBombasSection(props);

  return <VazaoBombasSectionView {...vm} />;
}

export type * from "./types-vazao-bombas-section";
